function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M17.5,18.3L17.5,18.3c0-1.2-1.8-2-4.3-2.4h0.3v-4.6c2.1-0.3,3.7-1.9,3.7-3.9c0-2.2-2-4-4.4-4H6.3c-0.4,0-0.8,0.3-0.8,0.8 s0.3,0.8,0.8,0.8h6.5c1.6,0,2.9,1.1,2.9,2.5c0,1.4-1.3,2.5-2.9,2.5H6.3c-1.6,0-2.9-1.1-2.9-2.5c0-0.5,0.2-0.9,0.5-1.3 C4.1,5.7,4.1,5.2,3.8,5C3.4,4.7,3,4.8,2.7,5.1C2.2,5.8,1.9,6.5,1.9,7.3c0,2,1.6,3.6,3.7,3.9v4.6h0.3c-2.4,0.4-4.3,1.2-4.3,2.4h0 c0,0.1,0,0.1,0,0.2v2.7c0,0.4,0.3,0.8,0.8,0.8h1.5l-1.1,6.8c-0.1,0.4,0.2,0.8,0.6,0.9c0,0,0.1,0,0.1,0c0.4,0,0.7-0.3,0.7-0.6l1.2-7 h8.3l1.2,7c0.1,0.4,0.4,0.6,0.7,0.6c0,0,0.1,0,0.1,0c0.4-0.1,0.7-0.5,0.6-0.9l-1.1-6.8h1.5c0.4,0,0.8-0.3,0.8-0.8v-2.7 C17.6,18.4,17.5,18.3,17.5,18.3z M16,17.7H3.2c0.9-0.6,3.1-1.2,6.4-1.2C12.9,16.5,15.1,17.1,16,17.7z M7.1,11.3H12v4.4 c-1.6-0.2-3.3-0.2-4.9,0V11.3z M16.1,20.4H3.1v-1.2h12.9V20.4z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.4,20.1L30.4,20.1l0-2.5c0-1.4-2.8-2.1-5.5-2.1c-2.6,0-5.5,0.7-5.5,2.1v2.5h0c0,1,1.4,1.6,3.1,1.9l-2.2,6.6 c-0.1,0.4,0.1,0.8,0.5,0.9c0.1,0,0.2,0,0.2,0c0.3,0,0.6-0.2,0.7-0.5l2.2-6.6c0-0.1,0-0.2,0-0.2c0,0,0.1,0,0.1,0v6.6 c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8v-6.6c0.1,0,0.1,0,0.2,0c0,0.1,0,0.2,0,0.2L28,29c0.1,0.3,0.4,0.5,0.7,0.5c0.1,0,0.2,0,0.2,0 c0.4-0.1,0.6-0.6,0.5-0.9L27.3,22C29,21.7,30.4,21.1,30.4,20.1z M24.9,16.5c2.9,0,4.5,0.8,4.5,1.1c0,0.3-1.6,1.1-4.5,1.1 c-2.9,0-4.5-0.8-4.5-1.1C20.4,17.3,22,16.5,24.9,16.5z M24.9,21.2c-2.9,0-4.5-0.8-4.5-1.1h0v-1.2c1.1,0.6,2.8,0.8,4.5,0.8 c1.7,0,3.4-0.3,4.5-0.8v1.2h0C29.4,20.4,27.8,21.2,24.9,21.2z"
});

var SvgProductSitzkissenIcon = function SvgProductSitzkissenIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Ebene_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgProductSitzkissenIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/product_sitzkissen_icon.d5278f66.svg";
export { ForwardRef as ReactComponent };